import React from 'react';

const MenuBack = () => {
    return (
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.7327 15.7905C8.0326 16.0762 8.5074 16.0646 8.7931 15.7647C9.0787 15.4648 9.0672 14.99 8.7673 14.7043L2.51587 8.7497H17.25C17.6642 8.7497 18 8.4139 18 7.9997C18 7.5855 17.6642 7.2497 17.25 7.2497H2.51577L8.7673 1.29502C9.0672 1.00933 9.0787 0.5346 8.7931 0.23467C8.5074 -0.06525 8.0326 -0.0768002 7.7327 0.20889L0.31379 7.2756C0.14486 7.4365 0.0449101 7.6417 0.0139301 7.8551C0.00479008 7.9019 0 7.9503 0 7.9997C0 8.0493 0.00480991 8.0977 0.0139799 8.1446C0.0450199 8.3579 0.14496 8.563 0.31379 8.7238L7.7327 15.7905Z" fill="#F4F4F4" />
        </svg>
    );
}

export default MenuBack;